<ion-header>
    <div>
        <ion-toolbar [ngClass]="{ 'offline-indicator': repService.isOfflineState }">
            <ion-buttons slot="start">
                <ion-button icon-only (click)="closePopover()">
                    {{ readOnlySignature ? ('CLOSE' | translate) : ('CANCEL' | translate) }}
                </ion-button>
            </ion-buttons>
            <ion-buttons *ngIf="!readOnlySignature" slot="end">
                <ion-button icon-only (click)="clearDraw()">
                    {{'CLEAR' | translate}}
                </ion-button>
                <ion-button icon-only padding-left [disabled]="!submitEnable" (click)="openConfirmationPopup()">
                    {{'SUBMIT' | translate}}
                </ion-button>
            </ion-buttons>
        </ion-toolbar>
    </div>

    <!-- Terms & Agreement block (fixed, only terms body scrolls) -->
    <div *ngIf="termsBody" class="sig-terms-block">
        <span class="sig-terms-label">{{'TERMS_CAP' | translate}}</span>
        <div class="sig-terms-body" [innerHTML]="termsBody"></div>
        <div *ngIf="agreementMessage" class="sig-agreement-text">{{ agreementMessage }}</div>
    </div>
</ion-header>
<ion-content [scrollY]="false">
    <!-- Read-only: show captured signature image -->
    <div *ngIf="readOnlySignature" class="sig-readonly-wrapper">
        <img [src]="readOnlySignature" class="sig-readonly-img" alt="Signature" />
    </div>

    <!-- Editable: signature pad -->
    <div *ngIf="!readOnlySignature" class="ion-text-center signaturePadWrapper">
        <img [src]="'assets/imgs/omni-sign-icon.svg'" class="redSignFlag">
        <signature-pad #sigPad [options]='signaturePadOptions' (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()"></signature-pad>
    </div>
</ion-content>
<ion-footer>
    <div class="ion-text-center popover-footer">
        {{ readOnlySignature ? ('SIGNATURE' | translate) : ('PLEASE_SIGN_ABOVE' | translate) }}
    </div>
</ion-footer>
